import React from 'react';
import { useMobileContext } from '../../contexts/MobileContext';
import PageShell from '../Layout/PageShell';
import SubPageHero from './SubPageHero';

import ScrollFadeWrapper from '../ScrollFadeWrapper/ScrollFadeWrapper';

import QuoteCarouselComponent from '../../components/HomePage/QuoteCarousel/QuoteCarouselComponent';

import PartnerBrandsComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsComponent';
import PartnerBrandsMobileComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsMobileComponent';
import partnerBrandsData from '../../json/components/HomePages/CarInsurance/partnerBrandsData.json';

import CustomerReviewsComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsComponent';
import CustomerReviewsMobileComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsMobileComponent';
import customerReviewsData from '../../json/components/HomePages/CarInsurance/customerReviewsData.json';

import HippoTwoLineGenericComponent from '../../components/Banners/HippoTwoLineGenericComponent';
import HippoGenericMobileComponent from '../../components/Banners/HippoGenericMobileComponent';

import KeyPointVerticalNumericComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericComponent';
import KeyPointVerticalNumericFourMobileComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericFourMobileComponent';
import keyPointVerticalNumericData from '../../json/components/HomePages/CarInsurance/keyPointVerticalNumericData.json';

import ScrollingCardsComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsComponent';
import ScrollingCardsMobileComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsMobileComponent';
import scrollingCardsData from '../../json/components/HomePages/CarInsurance/scrollingCardsData.json';
import scrollingCardsAllData from '../../json/components/HomePages/CarInsurance/scrollingCardsAllData.json';

import ThreeColumnCardComponent from '../../components/HomePage/ThreeColumnCard/ThreeColumnCardComponent';
import ThreeColumnCardMobileComponent from '../../components/HomePage/ThreeColumnCard/ThreeColumnCardMobileComponent';
import threeColumnCardData from '../../json/components/HomePages/CarInsurance/threeColumnCardData.json';

import vehiclePremiumScrollingCardsData from '../../json/components/HomePages/CarInsurance/fourColumnCardsData.json';
import scrollingCardsTipsAndGuidesData from '../../json/components/HomePages/CarInsurance/scrollingCardsTipsAndGuidesData.json';

import AccordionFAQComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQComponent';
import AccordionFAQMobileComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQMobileComponent';
import accordionFAQData from '../../json/components/HomePages/CarInsurance/accordionFAQData.json';

import ThreeCardCarGuideComponent from '../../components/HomePage/ThreeCardCarGuide/ThreeCardCarGuideComponent';
import ThreeCardCarGuideMobileComponent from '../../components/HomePage/ThreeCardCarGuide/ThreeCardCarGuideMobileComponent';
import threeCardCarGuideData from '../../json/components/HomePages/CarInsurance/threeCardCarGuideData.json';

import IndicativeQuotesComponent from '../../components/HomePage/IndicativeQuotes/IndicativeQuotesComponent';
import IndicativeQuotesMobileComponent from '../../components/HomePage/IndicativeQuotes/IndicativeQuotesMobileComponent';
import indicativeQuotesData from '../../json/components/HomePages/CarInsurance/indicativeQuotesData.json';

import SectionStepsComponent from '../../components/HomePage/SectionSteps/SectionStepsComponent';
import SectionStepsMobileComponent from '../../components/HomePage/SectionSteps/SectionStepsMobileComponent';
import sectionStepsData from '../../json/components/HomePages/CarInsurance/sectionStepsData.json';

import FourBlogCardsComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsComponent';
import FourBlogCardsMobileComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsMobileComponent';
import fourBlogCardsData from '../../json/components/HomePages/CarInsurance/fourBlogCardsData.json';

function CarInsurancePage({ pathName, heroGateKey, onHeroImageLoad }) {
  const isMobile = useMobileContext();
  const questionRoute = '/car-insurance-quote/step1';

  return (
    <PageShell gap={{ xs: '24px', sm: '48px', md: '64px' }}>
      <SubPageHero
        pathName={pathName}
        heroGateKey={heroGateKey}
        onImageLoad={onHeroImageLoad}
      />

      <QuoteCarouselComponent
        crossSellKey="latestCarInsuranceQuotes_CrossSell"
        fallbackKey="latestVehicleQuotes"
        navigateTo="/car-insurance-quote/step1"
      />

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <PartnerBrandsComponent data={partnerBrandsData} />
        ) : (
          <PartnerBrandsMobileComponent data={partnerBrandsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CustomerReviewsComponent data={customerReviewsData} />
        ) : (
          <CustomerReviewsMobileComponent data={customerReviewsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoTickle'}
            color={'blue'}
            title={'Looking for affordable car insurance?'}
            buttonText={'Compare quotes'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoTickle'}
            color={'blue'}
            title={'Looking for affordable car insurance?'}
            buttonText={'Compare quotes'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <SectionStepsComponent data={sectionStepsData} />
        ) : (
          <SectionStepsMobileComponent data={sectionStepsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <KeyPointVerticalNumericComponent
            data={keyPointVerticalNumericData}
          />
        ) : (
          <KeyPointVerticalNumericFourMobileComponent
            data={keyPointVerticalNumericData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsData} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoDontKnow'}
            imageDirection={'right'}
            title={'Dunno if your premium is too high?'}
            color={'blue'}
            buttonText={'Ask Hippo'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoDontKnow'}
            title={'Dunno if your premium is too high?'}
            buttonText={'Ask Hippo'}
            color={'blue'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <IndicativeQuotesComponent color="grey" data={indicativeQuotesData} />
        ) : (
          <IndicativeQuotesMobileComponent
            color="grey"
            data={indicativeQuotesData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={vehiclePremiumScrollingCardsData} />
        ) : (
          <ScrollingCardsMobileComponent
            data={vehiclePremiumScrollingCardsData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoThinkTilt'}
            imageDirection={'left'}
            color="blue"
            title={'You can find better and pay lesser'}
            buttonText={'Hippo it'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoThinkTilt'}
            title={'You can find better and pay lesser'}
            buttonText={'Hippo it'}
            color="blue"
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ThreeColumnCardComponent data={threeColumnCardData} />
        ) : (
          <ThreeColumnCardMobileComponent data={threeColumnCardData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ThreeCardCarGuideComponent data={threeCardCarGuideData} />
        ) : (
          <ThreeCardCarGuideMobileComponent data={threeCardCarGuideData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsTipsAndGuidesData} />
        ) : (
          <ScrollingCardsMobileComponent
            data={scrollingCardsTipsAndGuidesData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoHandSide'}
            imageDirection={'right'}
            color="blue"
            title={'Your easiest way to find better car insurance'}
            buttonText={'Compare quotes'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoHandSide'}
            title={'Your easiest way to find better car insurance'}
            buttonText={'Compare quotes'}
            color="blue"
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <FourBlogCardsComponent
            data={fourBlogCardsData}
            tag="car-insurance"
          />
        ) : (
          <FourBlogCardsMobileComponent
            data={fourBlogCardsData}
            tag="car-insurance"
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <AccordionFAQComponent data={accordionFAQData} />
        ) : (
          <AccordionFAQMobileComponent data={accordionFAQData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsAllData} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsAllData} />
        )}
      </ScrollFadeWrapper>
    </PageShell>
  );
}

export default CarInsurancePage;
